import cookies from 'js-cookie';

const isAuthenticated = () =>
  localStorage.getItem('authToken')?.length > 0 || cookies.get('.AspNetCore.Cookies')?.length > 0;



const getAuthToken = () => {
  if (localStorage.getItem('authToken')) {
    return localStorage.getItem('authToken');
  }
  if (cookies.get('.AspNetCore.Cookies')) {
    return cookies.get('.AspNetCore.Cookies');
  }
  return null;
};

const removeAuthToken = () => {
  localStorage.removeItem('authToken');
  cookies.remove('.AspNetCore.Cookies');
};



export { isAuthenticated, getAuthToken, removeAuthToken };


